"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const SortingView_1 = __importDefault(require("@react/web/Listing/Sorting/views/SortingView"));
class Sorting extends react_1.Component {
    render() {
        return (0, SortingView_1.default)({
            getOffersBySort: this.props.onSortingChange,
            sortBy: this.props.sortBy,
        });
    }
}
exports.default = Sorting;
